module.exports = __webpack_public_path__ + "static/media/pause.e5960e81.png";